import { TVideoCardFeatureV2 } from "pages/LayoutComponents/VideoCardGrid/VideoCardGrid.types";
import React from "react";
import { InstallationAddonsCarousel } from "./InstallationAddonsCarousel";
import { InView } from "react-intersection-observer";

export const InstallationAddonCarouselInView = ({
  items,
}: Readonly<{ items: Array<TVideoCardFeatureV2> }>) => {
  return (
    <InView as="div" threshold={0.1} trackVisibility delay={100}>
      {({ inView, ref }) => (
        <div ref={ref}>
          <InstallationAddonsCarousel items={items} isInView={inView} />
        </div>
      )}
    </InView>
  );
};
